/** Parses common Brazilian and international currency input into integer cents. */
export function parseCurrencyToCents(input: string): number | null {
  const value = input.trim().replace(/[^\d.,-]/g, '')
  if (!value) return null
  const normalized = value.includes(',')
    ? value.replace(/\./g, '').replace(',', '.')
    : (value.match(/\./g) || []).length > 1 ? value.replace(/\./g, '') : value
  const amount = Number(normalized)
  return Number.isFinite(amount) && amount >= 0 ? Math.round(amount * 100) : null
}
